import { render, staticRenderFns } from "./printVarieties.vue?vue&type=template&id=a56b5ba2&"
import script from "./printVarieties.vue?vue&type=script&lang=js&"
export * from "./printVarieties.vue?vue&type=script&lang=js&"
import style0 from "@@/core/pages/printVarieties/printVarietiesStyle.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports